import script from "./AddOrderPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOrderPoint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__